export default __webpack_public_path__ + "static/media/banner_po_kr@2x.bf4a7bf8.png";